import { ChainType } from "@0xsquid/squid-types";
import {
  ALBEDO_ID,
  FREIGHTER_ID,
  HANA_ID,
  HOTWALLET_ID,
  LOBSTR_ID,
  RABET_ID,
  XBULL_ID,
} from "@creit.tech/stellar-wallets-kit";
import { LEDGER_ID } from "@creit.tech/stellar-wallets-kit/modules/ledger.module";
import { StellarConnector } from "../../core/types/stellar";
import {
  ConnectorID,
  StellarWallet,
  WindowWalletFlag,
} from "../../core/types/wallet";
import { walletIconBaseUrl } from "../../core/wallets";
import { definedInWindow } from "./walletService";

type WalletOverride = Partial<
  Pick<
    StellarWallet,
    "icon" | "windowFlag" | "skipInstallCheck" | "isInstalled" | "connectorId"
  >
>;

const walletOverrides: Partial<Record<string, WalletOverride>> = {
  [ALBEDO_ID]: {
    icon: `${walletIconBaseUrl}/albedo.webp`,
    isInstalled: () => false,
    skipInstallCheck: true,
    connectorId: "albedo",
  },
  [HOTWALLET_ID]: {
    icon: `${walletIconBaseUrl}/hot.webp`,
    windowFlag: WindowWalletFlag.HotWallet,
    skipInstallCheck: true,
    connectorId: "hotWallet",
  },
  [RABET_ID]: {
    icon: `${walletIconBaseUrl}/rabet.webp`,
  },
  [LEDGER_ID]: {
    icon: `${walletIconBaseUrl}/ledger_stellar_snap.webp`,
  },
  [XBULL_ID]: {
    icon: `${walletIconBaseUrl}/xbull.webp`,
    windowFlag: WindowWalletFlag.XBull,
    skipInstallCheck: true,
    connectorId: "xBull",
  },
  [FREIGHTER_ID]: {
    connectorId: "freighter",
  },
  [LOBSTR_ID]: {
    connectorId: "lobstr",
  },
  [HANA_ID]: {
    connectorId: "hanaWallet",
  },
};

export function formatStellarWallet(
  connector: StellarConnector,
  isAvailable: boolean
): StellarWallet {
  const { productName, productId, productIcon, productUrl } = connector;

  const overrides = walletOverrides[productId];
  const icon = overrides?.icon || productIcon;
  const connectorId = overrides?.connectorId || (productId as ConnectorID);

  return {
    connectorId,
    name: productName,
    connectorName: productName,
    type: ChainType.STELLAR,
    icon,
    windowFlag: productName as WindowWalletFlag,
    isMobile: false,
    isInstalled: overrides?.windowFlag
      ? () => definedInWindow(overrides.windowFlag, window)
      : overrides?.isInstalled || (() => isAvailable),
    skipInstallCheck: overrides?.skipInstallCheck,
    connector,
    links: { website: productUrl },
  };
}
